import type NextGenBacklogType from '@jira/spa-apps__next-gen-backlog/src/BacklogWrapper.tsx';
import type { BacklogEntryPointProps } from '@jira/spa-apps__next-gen-backlog/src/BacklogWrapper.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';

export const LazyBacklogPage: LazyComponent<(props: BacklogEntryPointProps) => React.JSX.Element> =
	lazyForPaint<typeof NextGenBacklogType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-next-gen-backlog", jiraSpaEntry: "next-gen-backlog" */ '@jira/spa-apps__next-gen-backlog/src/BacklogWrapper.tsx'
				),
			),
		{ entryFsSsrLiftImportToModule: true },
	);
